import React, { useState } from "react";
import Dropzone from "react-dropzone";
import { Button, classNames } from "primereact";
import axios from "axios";
import { getCommonParam } from "../../config";
import { useToast } from "../../hooks/use-toast";

const PERMITTED_FILE_TYPE = "application/zip";

const MassiveLoading = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadDataEnable, setIsLoadDataEnable] = useState(false);
  const [response, setResponse] = useState(undefined);
  const [dataFile, setDataFile] = useState();
  const { toastRef } = useToast();

  const onRemoveFile = () => {
    setDataFile();
    setIsLoadDataEnable(false);
  };

  const handleOnDropFile = (acceptedFiles) => {
    try {
      if (!Array.isArray(acceptedFiles) || acceptedFiles.length !== 1) throw new Error("No file or multi file loaded");
      const file = acceptedFiles[0];
      const fileType = file.type;
      if (fileType !== PERMITTED_FILE_TYPE) throw new Error("Bad file type loaded");
      setIsLoadDataEnable(true);
      setDataFile(file);
    } catch (error) {
      console.log(error);
      toastRef.current.showToast("error", error.message, "");
    }
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setResponse();
      setIsLoading(true);
      const apiCommonParam = getCommonParam();
      const { apiUrl, companyId, axiosConfig } = apiCommonParam;
      const endpoint = `${apiUrl}/file/upload/${companyId}?file`;
      const formData = new FormData();
      formData.append("file", dataFile);
      const { data: res } = await axios.post(endpoint, formData, {
        axiosConfig: { ...axiosConfig.headers, "Content-Type": "multipart/form-data" },
      });
      toastRef.current.showToast(res.status === "Not imported" ? "error" : "success", res.status, "");
      setResponse(res);
      setIsLoadDataEnable(false);
      setDataFile();
    } catch (error) {
      console.error(error);
      toastRef.current.showToast("error", res.data.status, "");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="px-3 gap-2 w-full flex flex-column">
      <div className="text-600 font-medium text-600 text-xl mb-3">
        <span style={{ color: "black" }}>Caricamento Massivo</span>
      </div>
      <div className="text-base mb-3">
        <span>
          La trasmissione massiva consiste nel caricamento nella sezione dedicata del Portale di una cartella .zip
          contenente:
        </span>
        <ul>
          <li>Un Excel contenente i dati aziendali e di prodotto</li>
          <li>Una cartella contenente le immagini, sia aziendali che di prodotto, referenziate nel file Excel.</li>
        </ul>
        <span className="font-medium">NB</span>
        <ul>
          <li>
            è necessario compilare il file Excel messo a disposizione rispettando le seguenti restrizioni: per ogni
            foglio è previsto un set minimo di informazioni che è necessario fornire per consentire l’upload. Tali campi
            sono contrassegnati con colore viola e andranno obbligatoriamente valorizzati.
          </li>
          <li>
            il caricamento massivo non sostituirà i dati già inseriti, ma popolerà la piattaforma con i nuovi dati. Per
            modificare informazioni già inserite, si prega di modificare manualmente dall’interfaccia.
          </li>
        </ul>
      </div>

      <form encType="multipart/form-data" method="post" onSubmit={handleSubmit} accept="application/zip">
        <Dropzone onDrop={(acceptedFiles) => handleOnDropFile(acceptedFiles)} disabled={isLoadDataEnable}>
          {({ getRootProps, getInputProps }) => (
            <section className="border-3 border-dashed h-10rem  flex w-full justify-content-center align-items-center">
              {isLoadDataEnable ? (
                <div className="flex flex-column gap-1">
                  <div className="flex flex-row justify-content-center align-items-center  ">
                    <i className="pi pi-file " style={{ fontSize: "3rem" }}></i>
                    <Button
                      icon="pi pi-trash"
                      className="p-button-danger p-button-sm"
                      label="Remove"
                      onClick={onRemoveFile}
                    />
                  </div>
                  <div className="flex flex-row gap-1">
                    <span className="text-sm font-semibold ">Filename:</span>
                    <span className="text-sm">{dataFile && dataFile.name}</span>
                  </div>
                </div>
              ) : (
                <div {...getRootProps()}>
                  <input {...getInputProps()} />

                  <p>Trascina qui alcuni file oppure fai clic per selezionarli</p>
                </div>
              )}
            </section>
          )}
        </Dropzone>
        <Button
          disabled={!isLoadDataEnable || isLoading}
          className="mt-3 w-8rem"
          icon="pi pi-upload"
          label="Carica"
          type="submit"
          loading={isLoading}
        />
      </form>

      {!!response && (
        <div
          className={classNames(
            "flex w-full mt-3 flex-column border-1",
            response.status === "Not imported" ? "border-red-500" : "border-green-500",
            "p-4",
          )}
        >
          <span className="text-sm">Status: {response.status}</span>
          <span className="mt-2 text-sm">Notes:</span>
          <ul className="m-0">
            {response.notes.map((note, index) => (
              <li key={index}>
                <span className="text-sm">{note}</span>
              </li>
            ))}
          </ul>
          <span className="mt-2 text-sm">Warnings:</span>
          <ul className="m-0">
            {response.warnings.map((note, index) => (
              <li key={index}>
                <span className="text-sm">{note}</span>
              </li>
            ))}
          </ul>
          <span className="mt-2 text-sm">Errors:</span>
          <ul className="m-0">
            {response.errors.map((note, index) => (
              <li key={index}>
                <span className="text-sm">{note}</span>
              </li>
            ))}
          </ul>
        </div>
      )}

      <div className="flex w-full mt-3 ">
        <span className="text-lg underline">
          Clicca <a href="/ice-massive-loading.zip"> qui</a> per scaricare il modello dei dati.
        </span>
      </div>
    </div>
  );
};

export default MassiveLoading;
